import React from "react";

export const WiderrufPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="relative py-24 md:py-32 pt-28 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 -left-20 w-96 h-96 bg-gradient-to-r from-purple-600/30 to-orange-500/30 rounded-full blur-3xl animate-float" />
          <div
            className="absolute bottom-1/4 -right-20 w-80 h-80 bg-gradient-to-r from-orange-500/30 to-purple-600/30 rounded-full blur-3xl animate-float"
            style={{ animationDelay: "-3s" }}
          />
        </div>

        <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-6">
            Widerruf &amp;{" "}
            <span className="gradient-text font-medium">Stornobedingungen</span>
          </h1>
          <p className="text-base md:text-lg text-slate-200 max-w-3xl mx-auto leading-relaxed font-light">
            für Beratungs-, Coaching- und Transformationsleistungen von{" "}
            <strong>[FIRMENNAME / MARKE]</strong>
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 space-y-10 text-slate-800 text-sm md:text-base leading-relaxed">
          <p className="text-xs text-slate-500">
            Stand: <strong>[DATUM]</strong>
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            1. Kein gesetzliches Widerrufsrecht für Unternehmer
          </h2>
          <p>
            Unsere Leistungen richten sich ausschließlich an Unternehmer im Sinne
            von § 14 BGB, nicht an Verbraucher (§ 13 BGB). Für Unternehmer besteht
            kein gesetzliches Widerrufsrecht nach den Vorschriften über
            Fernabsatzverträge. Ein Widerrufsrecht im Verbrauchersinne wird von
            uns nicht eingeräumt.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            2. Stornierung und Umbuchung von Terminen
          </h2>
          <p>
            Wir wissen, dass sich Prioritäten im Business schnell verschieben können.
            Gleichzeitig blockieren unsere Programme und Sessions exklusive
            Zeitfenster und oft ganze Tage, in denen wir keine anderen Mandate
            annehmen können. Entsprechend gelten folgende Stornobedingungen:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Bis [X] Kalendertage vor Termin</strong>: kostenfreie
              Umbuchung oder Stornierung möglich.
            </li>
            <li>
              <strong>Zwischen [X] und [Y] Kalendertagen vor Termin</strong>:
              Stornogebühr in Höhe von{" "}
              <strong>[STORNO IN %]</strong>% des vereinbarten Honorars.
            </li>
            <li>
              <strong>Weniger als [Y] Kalendertage vor Termin</strong> oder bei
              Nichterscheinen („No-Show“): 100 % des vereinbarten Honorars werden
              fällig.
            </li>
          </ul>
          <p>
            Bereits angefallene, nachweisbare Reise-, Hotel- und
            Vorbereitungskosten sind im Falle einer Stornierung in voller Höhe vom
            Kunden zu tragen.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            3. Programme und mehrtägige Engagements
          </h2>
          <p>
            Bei Programmen (z. B. CultureBridge, Scrum4Sales Sprint, Change Sparring
            6, Leadership Resonanz Atelier) gelten zusätzlich folgende Grundsätze:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              Mit Vertragsabschluss wird eine Anzahlung in Höhe von{" "}
              <strong>[ANZAHLUNG IN %]</strong>% des Gesamtvolumens fällig.
            </li>
            <li>
              Diese Anzahlung ist nicht rückerstattbar, da damit Konzeption,
              Vorbereitung und exklusive Blockung von Kapazitäten abgegolten
              werden.
            </li>
            <li>
              Eine Verschiebung des Gesamtprogramms ist im Rahmen der oben
              genannten Fristen möglich; darüber hinausgehende Umbuchungen
              bedürfen individueller Abstimmung.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            4. Verschiebung oder Absage durch uns
          </h2>
          <p>
            Sollte aus wichtigen Gründen (z. B. Krankheit, höhere Gewalt,
            technische Störungen außerhalb unseres Einflussbereichs) ein Termin
            unsererseits verschoben oder abgesagt werden müssen, bieten wir
            zeitnah einen Ersatztermin an. Weitergehende Ansprüche bestehen nur im
            Rahmen der gesetzlichen Bestimmungen und der Haftungsregelungen unserer
            AGB.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            5. Form der Stornierung
          </h2>
          <p>
            Stornierungen und Umbuchungen müssen in Textform (z. B. E-Mail) an{" "}
            <strong>[KONTAKT-E-MAIL FÜR STORNO, Z. B. SOS@GLOBRIDGE.COM]</strong>{" "}
            erfolgen. Für die Einhaltung von Fristen ist der Eingang der
            Erklärung bei uns maßgeblich.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            6. Verhältnis zu den AGB
          </h2>
          <p>
            Diese Regelungen ergänzen unsere Allgemeinen Geschäftsbedingungen.
            Im Zweifel sind die Bestimmungen in den AGB maßgeblich. Bei
            Widersprüchen gehen die spezielleren Regelungen im jeweiligen
            Einzelvertrag bzw. Programm-Scope vor.
          </p>

          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            7. Kontakt
          </h2>
          <p>
            Für Rückfragen zu Stornierungen, Umbuchungen oder individuellen
            Vereinbarungen erreichen Sie uns unter:
          </p>
          <p>
            <strong>[FIRMENNAME]</strong>
            <br />
            <strong>[ANSCHRIFT]</strong>
            <br />
            E-Mail: <strong>[ALLGEMEINE KONTAKT-E-MAIL]</strong>
            <br />
            Telefon: <strong>[TELEFONNUMMER]</strong>
          </p>
        </div>
      </section>
    </div>
  );
};
